import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/forceSurvey/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/forceSurvey'
  }
]
